import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment'
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const AllianceSalesReportSourceDatamonthly = () => {
    const fileName = 'Alliance Sales Report Source Data (monthly)';
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const userData = JSON.parse(localStorage.getItem('userData'));
    const history = useHistory();
    const [aliiancSales, setAliiancSales] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const columns = [
        {
            Header: "ID",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
        },
        {
            Header: "Customer ID",
            accessor: "CustID",
            filter: "CustID",
            sortType: "basic",
        },
        {
            Header: "Ship To",
            accessor: "CustName",
            filter: "CustName",
            sortType: "basic",
            width: 300
        },
        {
            Header: "E-mail",
            accessor: "CustAddress",
            filter: "CustAddress",
            sortType: "basic",
            width: 250
        },
        {
            Header: "NDC",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
        }, {
            Header: "Product",
            accessor: "ProductDescription",
            filter: "ProductDescription",
            sortType: "basic",
            width: 300
        },

        {
            Header: "Size",
            accessor: "DosageORUnitsUMO",
            filter: "DosageORUnitsUMO",
            sortType: "basic",
        },
        {
            Header: "Quantity",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
        },
        {
            Header: "Unit",
            accessor: "SaleQTYUOM",
            filter: "SaleQTYUOM",
            sortType: "basic",
        },
        {
            Header: "$ Unit",
            accessor: "AcquisitionCost",
            filter: "AcquisitionCost",
            sortType: "basic",
        },
        {
            Header: "$ Net",
            accessor: "ContractPrice",
            filter: "ContractPrice",
            sortType: "basic",
        },
        {
            Header: "Total",
            accessor: "CIBDExtendedAmount",
            filter: "CIBDExtendedAmount",
            sortType: "basic",
        }, {
            Header: "Date",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "Account Type",
            accessor: "ContractReference",
            filter: "ContractReference",
            sortType: "basic",
        },
    ];
    useEffect(() => {
        getAliiancSales();
    }, [])
    async function getAliiancSales() {
        setLoading(true);
        let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=SalesMonthly&TaskTypeCode=AllianceSales`;
        await _HttpServices
            .getData(url)
            .then((data) => {
                const aliiancSalesResult = data.data;
                if (aliiancSalesResult.length > 0) {
                    aliiancSalesResult.map((res) => {
                        res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format('MM/DD/YYYY');
                        res.CIBDExtendedAmount = "$" + (res.CIBDExtendedAmount * 1).toFixed(2)
                        res.AcquisitionCost = "$" + (res.AcquisitionCost * 1).toFixed(2)
                        res.ContractPrice = "$" + (res.ContractPrice * 1).toFixed(2)
                    })
                }
                setAliiancSales(aliiancSalesResult);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                setHasError(true);
            });
    }
    const EditRecords = () =>{
        localStorage.setItem("aliiancSales",JSON.stringify(aliiancSales));
        history.push("/AllianceSalesEdit")
    }
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Alliance Sales Report Source Data</h2>
                {loading ? <Loader /> : null}
                <div>
                {aliiancSales.length > 0 &&userData.RoleID === 1 &&
                 (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}
                <Button type="submit" className="ml-2" onClick={() => getExcel(columns, aliiancSales, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                </div>
            </div>
            <Row>
                <Col md={12}>
                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                                {hasError ? <p>Error occurred. Unable to load Alliance Sales Report Source Data (monthly).</p> :
                                    <Fragment>
                                        {aliiancSales.length > 0 ? (
                                            <ReactTable columns={columns} data={aliiancSales} defaultPageSize={10} />
                                        ) : (
                                                <div className="no-data">No data found.</div>
                                            )}
                                    </Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={12} className="text-right mt-2">
                    <Button
                        variant="danger"
                        type="button"
                        className="ml-3"
                        onClick={() => history.goBack()}
                    >
                        <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
                </Col>
            </Row>
            <Footer />
        </section>
    );

}

export default AllianceSalesReportSourceDatamonthly;